import * as React from 'react';
import { useTranslation } from 'react-i18next';
import LocationSelectionPage from './LocationSelectionPage';
import BookingDialogLayout from '../layout/components/BookingDialogLayout';
import FullScreenDialog from '../common/FullScreenDialog';

interface Props {
    openSelectLocationDialog: boolean
    handleClickOpen: () => void
    handleClose: () => void
}

export default function SelectLocationDialog({ handleClose, openSelectLocationDialog }: Props) {
    const { t } = useTranslation();

    return (
        <FullScreenDialog
            open={openSelectLocationDialog}
            onClose={handleClose}
            ariaLabel={t('common.dialog.location_selection')}
            // The legacy MUI full-screen dialog spanned the whole viewport;
            // lift the booking-flow max-w-md constraint to keep that layout.
            className="max-w-none"
        >
            <BookingDialogLayout handleClose={handleClose} handleClickBack={handleClose}>
                <LocationSelectionPage />
            </BookingDialogLayout>
        </FullScreenDialog>
    );
}
